import { ChevronDown, X } from 'lucide-react'

function MultipleSelect(props) {
  const { data, onDelete, onClick } = props
  return (
    <div
      className="w-full border rounded-2 d-flex justify-content-between cursor-pointer"
      style={{ minHeight: '45px' }}
      role="button"
      tabIndex={0}
      onClick={(e) => {
        e.stopPropagation()
        onClick()
      }}
    >
      <div
        className="d-flex flex-column justify-content-center fs-6 ms-2 w-100"
        style={{ marginTop: '0rem' }}
      >
        <div
          className="d-flex flex-wrap gap-2"
          style={{
            paddingTop: '5px',
            paddingBottom: '5px',
            paddingRight: '10px'
          }}
        >
          {data?.map((dataValue) => (
            <button
              key={dataValue.value}
              className="border rounded-2 d-flex align-items-center gap-2 py-1 px-2 checker-value"
              style={{
                height: '28px',
                border: '1px solid #dee2e6',
                backgroundColor: 'white',
                width: 'auto',
                padding: '0 8px'
              }}
              onClick={(e) => {
                e.stopPropagation()
                onDelete(dataValue.value)
              }}
            >
              <X size={12} className="text-muted" />
              <span
                style={{
                  fontSize: '12px',
                  fontWeight: '500',
                  lineHeight: '1',
                  whiteSpace: 'nowrap'
                }}
              >
                {dataValue.label}
              </span>
            </button>
          ))}
        </div>
      </div>
      <div className="d-flex flex-column justify-content-center fs-6 me-3">
        <ChevronDown size={12.5} />
      </div>
    </div>
  )
}

export default MultipleSelect
